import { Typography } from "@material-ui/core";
import styled from "styled-components";

import baseStyles from "./baseStyles";

export default styled(Typography).attrs({ component: "span" })`
  ${baseStyles}
`;
